import { useState } from 'react';
import { Card, Col, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AiOutlineClose } from 'react-icons/ai';
import { BiLogOut } from 'react-icons/bi';

import { PSButton } from '@/components/ui/button';
import { PSLink } from '@/components/ui/link';
import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

import { useGetProfileQuery } from '../../../app/services/auth-rtk.service';
import DeleteAccount from '../../../components/deleteaccount/DeleteAccount';
import { MultiLanguageUrl } from '../../../constants/multiLanguage.constant';
import ProfileChangeEmail from './profile-change-email/profile-change-email.page';
import ProfileChangePassword from './profile-change-password/profile-change-password';
import ProfileInfoEditPage from './profile-info-edit/profile-info-edit.page';

const ProfilePage = () => {
  const { t, i18n } = useTranslation();
  const profile = useGetProfileQuery();
  const [showLogOutPopUp, setShowLogOutPopUp] = useState(false);
  const [showUpdatePasswordModal, setShowUpdatePasswordModal] = useState(false);
  const [showUpdateEmailModal, setShowUpdateEmailModal] = useState(false);
  const [showUpdateAccountInfoModal, setShowUpdateAccountInfoModal] = useState(false);

  return (
    <>
      <div className="mt-0 bg-layout-backgroundColor">
        <Row className="py-2 px-1 border-bottom align-items-center bg-secondColor m-0">
          <Col lg="9" sm="9" xs="9" className="p-0">
            <h3 className="m-0 tw-ps-5">{t('ProfilePage/title')}</h3>
          </Col>
        </Row>

        <Card>
          <Card.Body className="p-lg-5 w-100 bg-layout-backgroundColor">
            <Row>
              <Col className="d-flex flex-column gap-2">
                <label className="fs-5">
                  {profile?.data?.user_first_name ? profile?.data?.user_first_name + ' ' : '' || ''}

                  {profile?.data?.user_last_name || ''}
                </label>
                <span className="fs-6 text-light">{profile?.data?.user_user_name ? '@' + profile?.data?.user_user_name : ''}</span>
              </Col>
              <Col className="d-flex justify-content-end">
                <PSButton
                  id="btn-profile-show-update"
                  variant="secondary"
                  onClick={() => setShowUpdateAccountInfoModal(true)}
                  title={t('ProfilePage/btn-01')}
                />
              </Col>
              <div className="w-100 m-2">
                <hr />
              </div>
            </Row>
            <Row>
              <Col className="d-flex flex-column gap-1">
                <label className="form-label">{t('ProfilePage/l-01')}</label>
                <span className="fs-5">{profile?.data?.user_email}</span>
              </Col>
              <Col className="d-flex justify-content-end">
                <PSButton id="btn-profile-hide-update" variant="secondary" onClick={() => setShowUpdateEmailModal(true)} title={t('ProfilePage/btn-04')} />
              </Col>
              <div className="w-100 m-2">
                <hr />
              </div>
            </Row>
            <Row>
              <Col className="d-flex flex-column gap-1">
                <label className="form-label">{t('ProfilePage/l-02')}</label>
                <span className="fs-5">************</span>
              </Col>
              <Col className="d-flex justify-content-end">
                <PSButton id="btn-profile-show-password" variant="secondary" onClick={() => setShowUpdatePasswordModal(true)} title={t('ProfilePage/btn-02')} />
              </Col>
              <div className="w-100 m-2">
                <hr />
              </div>
            </Row>

            <Row className="tw-my-4">
              {/* /Delete account */}
              <DeleteAccount></DeleteAccount>
            </Row>

            <Row>
              <Col className="d-flex justify-content-end">
                <PSButton
                  id="btn-profile-show-logout"
                  variant="secondary"
                  onClick={() => setShowLogOutPopUp(true)}
                  icon={<BiLogOut size={24} />}
                  title={t('ProfilePage/btn-03')}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>

      <ProfileChangePassword showModal={showUpdatePasswordModal} setShowModal={setShowUpdatePasswordModal} />

      <ProfileInfoEditPage showModal={showUpdateAccountInfoModal} setShowModal={setShowUpdateAccountInfoModal} />

      <ProfileChangeEmail showModal={showUpdateEmailModal} setShowModal={setShowUpdateEmailModal} />

      {showLogOutPopUp && (
        <Modal show={showLogOutPopUp} centered onHide={() => setShowLogOutPopUp(false)}>
          <Row className="m-0">
            <Col className="tw-pt-4 tw-ps-4">
              <AiOutlineClose className="tw-cursor-pointer" onClick={() => setShowLogOutPopUp(false)} />
            </Col>
          </Row>
          <Modal.Body className="text-center tw-px-14 tw-pb-14 tw-pt-20 ">
            <Row>
              <Col className="tw-flex  tw-justify-center">
                <div className="tw-border-solid tw-w-20 tw-h-20 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border-slate-50 tw-border-[12px]">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_2596_3315)">
                      <path
                        d="M17.964 3.13288C17.766 2.78801 17.4806 2.50148 17.1364 2.30223C16.7923 2.10297 16.4017 1.99805 16.004 1.99805C15.6064 1.99805 15.2157 2.10297 14.8716 2.30223C14.5275 2.50148 14.242 2.78801 14.044 3.13288L0.330014 26.4669C-0.583986 28.0229 0.512014 30.0009 2.29001 30.0009H29.716C31.494 30.0009 32.592 28.0209 31.676 26.4669L17.964 3.13288ZM16 10.0009C17.07 10.0009 17.908 10.9249 17.8 11.9909L17.1 19.0049C17.0765 19.2804 16.9504 19.5371 16.7467 19.7241C16.543 19.9112 16.2766 20.015 16 20.015C15.7235 20.015 15.457 19.9112 15.2533 19.7241C15.0496 19.5371 14.9235 19.2804 14.9 19.0049L14.2 11.9909C14.1749 11.7393 14.2027 11.4853 14.2817 11.2452C14.3607 11.0051 14.4891 10.7842 14.6587 10.5967C14.8283 10.4092 15.0352 10.2594 15.2663 10.1567C15.4973 10.0541 15.7472 10.001 16 10.0009ZM16.004 22.0009C16.5344 22.0009 17.0432 22.2116 17.4182 22.5867C17.7933 22.9617 18.004 23.4704 18.004 24.0009C18.004 24.5313 17.7933 25.04 17.4182 25.4151C17.0432 25.7902 16.5344 26.0009 16.004 26.0009C15.4736 26.0009 14.9649 25.7902 14.5898 25.4151C14.2147 25.04 14.004 24.5313 14.004 24.0009C14.004 23.4704 14.2147 22.9617 14.5898 22.5867C14.9649 22.2116 15.4736 22.0009 16.004 22.0009Z"
                        fill="#FDB139"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2596_3315">
                        <rect width="32" height="32" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </Col>
            </Row>
            <Row className="tw-mt-8">
              <Col>
                <h2 className="font-sofiaSans tw-text-sm ">{t('DashboardMenu/l-08')}</h2>
              </Col>
            </Row>
            <Row>
              <Col>
                <p className="font-sofiaSans  tw-text-zinc-500 ">{t('DashboardMenu/text-01')}</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <PSLink variant="outlineWarning" to={`/${MultiLanguageUrl[i18n.language] || 'en-US'}/logout`} className="tw-w-full">
                  {t('DashboardMenu/l-08')}
                </PSLink>
              </Col>
            </Row>
            <Row className="tw-mt-5">
              <Col>
                <PSButton
                  id="btn-profile-menu"
                  variant="primary"
                  className="w-100 tw-flex tw-justify-center"
                  onClick={() => setShowLogOutPopUp(false)}
                  title={t('DashboardMenu/l-09')}
                />
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default WrappedErrorBoundary(ProfilePage);
